import { Component, inject } from '@angular/core';
import { NurseryActivityParameterService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import { ConfirmationService } from '@abp/ng.theme.shared';
import {
  NurseryActivityParameterCreateDto,
  NurseryActivityParameterDto,
  NurseryActivityParameterExcelDownloadDto,
  NurseryActivityParameterUpdateDto,
} from '../proxy/controlling/dtos/nursery-activity-parameter';
import { NURSERYACTIVITYPARAMETER_CONFIG, NURSERYACTIVITYPARAMETER_FIELDS } from './nursery-activity-parameter.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm, ZnHierarchicalViewComponent} from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-nursery-activity-parameter',
  imports: [
    CommonModule,
    CrudPage,
    GenericForm,
    ZnHierarchicalViewComponent
  ],
  providers: [ListService, NurseryActivityParameterService, ConfirmationService],
  templateUrl: './nursery-activity-parameter.html',
  styleUrl: './nursery-activity-parameter.scss',
})
export class NurseryActivityParameter extends BaseHierarchicalCrudComponent<
  NurseryActivityParameterDto,
  NurseryActivityParameterCreateDto,
  NurseryActivityParameterUpdateDto,
  NurseryActivityParameterExcelDownloadDto
> {
  service = inject(NurseryActivityParameterService);
  config = NURSERYACTIVITYPARAMETER_CONFIG;
  fields = NURSERYACTIVITYPARAMETER_FIELDS;

  protected prepareUpdateDto(data: any, selected: NurseryActivityParameterDto): NurseryActivityParameterUpdateDto {
    return {
      hasRfid: data.hasRfid,
      isProductive: data.isProductive,
      mustMoveStock: data.mustMoveStock,
      activityProcessParametrizationId: data.activityProcessParametrizationId,
      levelId: data.levelId,
      stageId: data.stageId,
      wbsId: data.wbsId,
      movementTypeId: data.movementTypeId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'NurseryActivityParameter';
  }
}
